import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { Asset } from '../../types/Asset'
import { isObjectEmpty } from '../../utils/utils'

type IProps = {
    asset: Asset
    icon: string
    title: string
    titleIcon?: Icon
    subtitle: string
    legends: LegendProp[]
    backgroundImg: string
    enableImg: boolean
    enableOpt: boolean
    dividerSize: number
}

type Status = {
    icon?: string
    color?: string
    text?: string
}

type Icon = {
    icon?: string
    color?: string
}

const FormHeader = ({
    asset = {},
    icon = '',
    title = '',
    subtitle = '',
    legends = [],
    backgroundImg = '',
    enableImg = false,
    enableOpt = true,
    titleIcon = {},
    dividerSize = 20
}: IProps): JSX.Element => {
    return (
        <>
            {/* <ModalDeleteDriver apply={applyRemoveDriver} driver={state.driverSelected} /> */}
            <HeaderCointainer enableImg={enableImg} backgroundImg={backgroundImg} titleIconColor={titleIcon?.color}>
                <div className="header-info">
                    <div className="header-primary-info">
                        <div className="header-icon">
                            <i className={icon}></i>
                        </div>
                        <div className="header-title">
                            <div>
                                <strong>{title || 'N/A'}</strong>
                                <div className="header-title-icon">
                                    {!isObjectEmpty(titleIcon) && <i className={`${titleIcon?.icon}`}></i>}
                                </div>
                            </div>
                            <span>{subtitle}</span>
                        </div>

                        {asset?.id && enableOpt ? (
                            <>
                                <Divider size={20} />
                                {/* <MenuDropdownActions driver={driver} /> */}
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                    <Divider size={dividerSize} margin={'0px 20px'} />
                    <div className="header-secondary-info">
                        {legends.map(legend => {
                            return (
                                <LegendStyle color={legend.color}>
                                    <i className={legend.icon}></i>
                                    {legend.value}
                                </LegendStyle>
                            )
                        })}
                    </div>
                </div>
            </HeaderCointainer>
        </>
    )
}
export type LegendProp = {
    icon: string
    value: string
    color: string
}
const HeaderCointainer = styled.div`
    font-family:${({ theme }) => theme['font-regular']};
    width: 100%;
    height:130px;
    background-color:${({ theme }) => theme['gray-0']};
    border-bottom:1px solid ${({ theme }) => theme['gray-200']};
    display:flex;
    ${({ enableImg, backgroundImg }) => {
        return (
            enableImg &&
            css`
                background-position: right;
                background-image: url(${backgroundImg});
                background-repeat: no-repeat;
            `
        )
    }}


    &&{
        .header-info{
            display:flex;
            align-items: center;
            padding:20px;
            justify-content:start;
            width:100%;
            background-image: ${({ theme }) => `linear-gradient(to right, ${theme['gray-0']} 60%, transparent);`}; 
            /* background-color:${({ theme }) => theme['gray-0']}; */
        
            .header-primary-info{
                display:flex;
                justify-content:space-between;
                padding: 10px 0px 10px 10px;
                
                >div{
                    margin-right: 10px;
                }

                .header-icon{
                    padding:12px 14px;
                    background-color:${({ theme }) => theme['gray-800']};
                    font-size:22px;
                    line-height:24px;
                    color: #FFFFFF;
                    border-radius:3px;
                }

                .header-title{
                    display:flex;
                    flex-direction:column;

                    .header-title-strong{
                        color:${({ theme }) => theme['gray-800']};
                        font-size:20px;
                        font-style:normal;
                        line-height:24px;
                        font-weight:600;
                        display: flex;
                        align-items: center;
                    }

                    .header-title-icon{
                        color:${({ titleIconColor }) => titleIconColor};
                        margin-left:5px;
                        font-style: normal;
                        font-weight: 900;
                        font-size: 14px;
                        line-height: 16px;
                    }

                    >span{
                        color: ${({ theme }) => theme['gray-800']};
                        font-size:14px;
                        line-height:24px;
                        font-weight:normal;
                    }

                }

                .driver-dropdown{
                    color:${({ theme }) => theme['blue-500']};
                    >i{
                        margin-right:5px;
                    }
                }
            }
            .header-secondary-info{
                    display: flex;
                    flex-direction: column;
                    justify-content:space-evenly;
                    height:100%;
                    margin-left:10px;
            }
        }
        
    }
    
`

const LegendStyle = styled.span`
    color: ${({ color }) => color};
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
    > i {
        margin-right: 5px;
    }
`
const Divider = styled.div`
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme['gray-darker-bg']};
    height: ${({ size }) => size}px;
    width: 0px;
    margin: ${({ margin }) => margin};
`

export default FormHeader
